
import { supabase } from "@/integrations/supabase/client";
import { AdminUser } from "@/types/admin";

export const fetchAdminUsersList = async (
  page: number, 
  pageSize: number, 
  searchQuery: string
) => {
  let query = supabase
    .from('admin_users')
    .select('*', { count: 'exact' });
  
  // Add search filter if search query exists
  if (searchQuery) {
    query = query.ilike('email', `%${searchQuery}%`);
  }
  
  // Add pagination
  query = query.range((page - 1) * pageSize, page * pageSize - 1)
    .order('created_at', { ascending: false });
  
  const { data, error, count } = await query;

  if (error) throw error;
  
  return { data, count };
};

export const removeAdminUserById = async (userId: string) => {
  const { error } = await supabase
    .from('admin_users')
    .delete()
    .eq('id', userId);

  if (error) throw error;
};
